<template>
  <div :class="['container', { 'container-dark': theme_dark }]">
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">礼物投诉</div>
      <div class="nav-right">
        <span class="nav-lable"></span>
        <img src="../../assets/img/返回箭头.png" class="nav-img none" />
      </div>
    </div>
    <div class="ts">
     <span>冻结金额是指最近24小时收到的礼物对应的金额，24小时内未收到礼物投诉，则冻结金额解冻，可进行提现。</span>
    </div>
    
    <li v-for="(item, index) in data" :key="index" class="item">
        <div class="main">
          <div class="receive">
            <img :src="item.photo_url" />
            <span>{{ item.nick }}</span>
          </div>
          <div class="send">
            <span>赠送</span>
            <img src="../../assets/img/右箭头.png" />
            <span>{{ item.dtm }}</span>
          </div>
          <div class="gift">
            <img :src="item.gift_url" />
            <span>{{ item.gift_name }}</span>
          </div>
        </div>
        <div class="tousu" @click="goto_gift_touSu2_dtl(item.id)">详情</div>
      </li>

    <div class="btn ub ub-pc ub-ac"  v-if="data.length > 0">
      <div class="loadmore" @click="load_more()" >
        加载更多
      </div>
    </div>
    <div class="ts-tip1" v-if="data.length <= 0">
      恭喜你，最近24小时内未收到礼物投诉
    </div>
  </div>
</template>

<script>
import * as tool from "../../api/common";
import { mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      data: [],
      index: 0,
      size: 10,
      theme_dark: false
    };
  },
  mounted() {
    //切换深色模式
    this.theme_dark = tool.is_theme_dark(this);
    this.init();
  },
  methods: {
    ...mapMutations(["get", "post"]), //引入方法
    back() {
      this.$router.go(-1); //返回上一层
    },
    goto_gift_touSu2_dtl(id) {
      this.$router.push({ name: "gift_touSu2_dtl", params: { id: id } });
    },
    init() {
      this.load_more();
    },

    load_more() {
      this.$loading("加载...");

      var const_data = this.$store.state.const_data;
      var ary_gift = const_data.gift_1.concat(const_data.gift_2);

      //计算index
      var index = parseInt(this.data.length / this.size);
      if (index > this.index || (index == 0 && this.data.length == 0)) {
        this.index = index;
      } else {
        this.$toast.center("没有更多了~");
        this.$loading.close();
        return false;
      }

      //加载数据(按条数加载)
      var self = this;
      self.get({
        url:"/App/GetLeastGift_Tosu/?uid=" +this.$store.state.uid +"&index=" +this.index +"&size=" +this.size,
        success: function (data) {
          //console.log(JSON.stringify(data));
          self.$loading.close();
          if (data) {
            for (var i = 0; i < data.length; i++) {
              data[i].photo_url =
                self.$store.state.url + "/photo/" + data[i].photo;
              var gift_item = tool.getGiftItemBy_name(
                ary_gift,
                data[i].gift_name
              );
              data[i].gift_url = gift_item.url;
            }
            self.data = self.data.concat(data);
          }
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: 100vh;
  background-color: #EFEFEF;
}
.ts {
  margin: 0.5rem 0.8rem;
  span {
    font-size: 0.75rem;
    color: #888;
    line-height: 1.3rem;
  }
}

.item {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.8rem;
  justify-content: space-between;
  background-color: #fff;
  .main {
    display: flex;
    align-items: center;
    .receive {
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        border-radius: 50%;
        width: 3rem;
        margin: 0.4em 0;
      }
      span {
        font-size: 0.8rem;
        color: #666;
      }
    }
    .send {
      padding: 0 0.3rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      span {
        font-size: 0.7rem;
        color: #666;
      }
      img {
        width: 9rem;
        height: 0.8rem;
      }
    }
    .gift {
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 3rem;
      }
      span {
        font-size: 0.8rem;
        color: #666;
      }
    }
  }
  .tousu {
    padding: 0.3rem 0.9rem;
    text-align: center;
    border: 1px solid #dfdfdf;
    height: 1.5rem;
    line-height: 1.5rem;
    color: #32cd32;
    width: 3rem;
    font-size: 0.95rem;
    border-radius: 0.3rem;
  }
}

.btn {
  margin: 1rem 0;
  .loadmore {
    padding: 0.5rem 8rem;
    background: linear-gradient( 90deg, #8A61FF 13%, #FE9CC0 91%);
    color: #fff;
    font-size: 0.9rem;
    font-weight: bold;
    border-radius: 1rem;
  }
}

.ts-tip1 {
  padding: 0.8em;
  font-size: 0.9rem;
  color: #BA61FF;
  text-align: center;
}

.container-dark {
  background-color: #2f2e33;
  .item {
    background-color: #2c2b30;
    .main {
      .gift {
        span {
          color: #fdfdfd;
        }
      }
      .send {
        span {
          color: #888;
        }
      }
      .receive {
        span {
          color: #fdfdfd;
        }
      }
    }
    .tousu {
        .txt {
          color: #888;
        }
      }
  }
}
</style>